export enum Keys {
  ENTER = 13,
  SPACE = 32,
}
